// @flow
import ImageClickable from './ImageClickable';

export default ImageClickable;
